export const CONTENT_ITEMS = {
    LOGIN_FORM: 'BAD413DA-EF54-411A-8EA2-48B4DF76D479',
    LOGIN_ERROR: '31EFB5B4-D35E-4564-B748-DE4382A0F930',
    EDIT_FORM: '64C4C04D-45F9-425E-94BC-2E6D38FFC01C',
    AGENT_FORM: '81310BBF-9037-4E77-A646-0C86C4198A1E',
    AGENTS_LIST: '0DC9E933-A3FA-41D3-A94A-5F412AAD8635',
    AGENTS_FILTERS: 'AB3AC8B3-62F3-45D2-AA0D-01EEC55B3E53',
    REMOVE_PROFILE_MODAL: 'ABDC8B98-DE14-4CF2-9969-E7F2D6EDD5E2',
    RESET_PASSWORD_MODAL: '64F85CD2-86E3-4E77-841A-97D701422234',
    PENDING_REQUESTS_LIST: 'BB13BF10-C01B-4DEA-914E-9AE3C26FFC88',
    PENDING_REQUESTS_SELECTION: '3B056434-9BB8-42F1-A295-AC850103F231',
    UPDATE_PENDING_REQUESTS_MODAL: '4498CC78-7374-4972-8193-AF9E6A96E7D4',
    AGENCY_TERM_AND_TIER: '62A87AEF-BA19-42FF-9784-919D35775B0F',
    AGENCY_TERMS_AND_CONDITIONS: '9735405F-976A-4C32-8095-F5379B57E017',
    ACKNOWLEDGEMENT_TERMS_AND_CONDITIONS: '8AF5F74E-00B5-4918-B8BC-6869B09B4B47',
    AGENCY_COMMISSION_AND_DETAILS: 'B7177163-D123-4E2D-B88D-76214BA67E61',
    ACKNOWLEDGEMENT_TIME_STAMP: '86F71D9D-EE1D-4C3D-93F1-9ED4B84F9083',
    TRAVEL_AGENT_FINDER_EDIT_FORM: '83E583F1-17AD-40F6-9126-D7ED946E3FF9'
};

export const PAGES_CONTENT_ITEMS = {
    LOGIN: '2F8C3ADD-1A56-48E8-9CDF-E5AAF599918C',
    FORGOT_PASSWORD: '89FD7FCC-873D-4067-8908-1E4FBBA1B3A2',
    FORGOT_USERNAME: '96E39200-CB79-4147-B73E-2CBBB26C2350',
    RESET_PASSWORD: 'FEC547A5-4922-4293-A673-A7A97EEC584B',

    MY_PROFILE: '21C354B5-ED72-4F8D-A58A-87EF354A149A',
    EDIT_PROFILE: 'B1AC7B54-5787-4355-B89E-CA7BFFBBFF1C',

    AGENCY_VIEW: '71C3E0AC-5308-451B-A835-3E717E2F6797',
    AGENCY_COMMISSIONS: '64518913-7A2D-4D91-A6E2-981303FC5D31',

    MANAGE_AGENTS: 'E48FA1E4-336B-458B-9B5D-2EBDD58CBA6D',
    EDIT_AGENT: 'C240E1FF-45B6-4661-9768-1B99F7783DB9',
    ADD_AGENT: '33D579B5-2128-4028-A7CC-D06C75F9F817',

    PENDING_REQUESTS: '2174EF84-6312-44FA-A9E2-93E024054276',

    PRODUCT_FILES: 'DDD73573-0855-4273-A224-3BDEE4F93B11',

    VIEW_TRAVEL_AGENT_FINDER: '1C9874A4-B79F-4575-8B7F-74DC3D6DD566',
    EDIT_TRAVEL_AGENT_FINDER: 'B75F24CA-5103-4F69-A5A0-B54CCFD07DB1'
}